import {cursorIdeViewBox, mdiCursorIde} from './cursor-ide';

/** SVG path data for mdi-vue icons not in @mdi/js. */
export const customIcons = {
  mdiCursorIde,
};

/** Non-square viewBoxes for custom icons (mdi-vue defaults to 0 0 24 24). */
export const customIconViewBoxes: Record<string, string> = {
  'cursor-ide': cursorIdeViewBox,
};
